import './BikeElevationInformation.scss'

import { HDSIcon } from '@here/hds-react-components'
import React from 'react'
import { CountryAndUnit, formatDistance } from 'utils/formatters'

export interface BikeElevationInfo {
  elevation_down: number
  elevation_up: number
}
interface BikeElevationInformationProps {
  elevationInfo?: BikeElevationInfo
  countryAndUnit: CountryAndUnit
}

export default function BikeElevationInformation({
  elevationInfo,
  countryAndUnit,
}: BikeElevationInformationProps): JSX.Element {
  return (
    <>
      {elevationInfo !== undefined ? (
        <span className="ElevationInfo">
          <span className="ElevationInfo_arrow_container">
            <HDSIcon
              name="arrow-up-right"
              size="16px"
              category="core-ui"
              className="ElevationInfo_arrow"
            />
            {formatDistance(elevationInfo?.elevation_up, countryAndUnit)}
          </span>
          <span className="ElevationInfo_arrow_container">
            <HDSIcon
              name="arrow-down-right"
              size="16px"
              category="core-ui"
              className="ElevationInfo_arrow"
            />
            {formatDistance(elevationInfo?.elevation_down, countryAndUnit)}
          </span>
        </span>
      ) : null}
    </>
  )
}
